import React, { useContext, useEffect, useState } from 'react'

import { useI18n } from '@shopify/react-i18n'
import { ButtonV2, Text, Menu } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import filterContext from '@/components/pages/production/components/context'
import { FilterFields } from '@/components/pages/production/components/context/types'
import ListingsContext from '@/context/listings'
import { getHighestFilterPrice } from '@/utils/filters'
import { getFormattedCurrency } from '@/utils/i18n'

import styles from './styles.module.scss'

interface Props {
    onClick: (option: any) => void
    isChanged?: boolean
}

const PriceFilterButton: React.FC<Props> = ({ onClick }) => {
    const {
        state: { priceFilterState, modifiedFilterList, showAllInPrice },
    } = useContext(filterContext)
    const {
        selectors: { i18nListingsData, globalPriceRangeObject: priceRangeObject },
    } = useContext(ListingsContext)

    const [i18n] = useI18n()

    const btnClassname = classNames(styles.filterButton, {
        [styles.isChanged]:
            !!modifiedFilterList.includes(FilterFields.PriceRange) ||
            !!modifiedFilterList.includes(FilterFields.AllInPrice),
    })

    const { currentMin, currentMax } = priceFilterState
    const highestFilterPrice = getHighestFilterPrice(priceRangeObject, showAllInPrice)
    const highestGlobalPrice = showAllInPrice ? priceRangeObject.highestAllInPrice : priceRangeObject.highestPrice
    const priceMaxed = highestFilterPrice === currentMax
    const plusSignString = priceMaxed && highestFilterPrice < highestGlobalPrice ? '+' : ''
    const [buttonLabel, setButtonLabel] = useState('')

    useEffect(() => {
        const label = `${getFormattedCurrency(
            i18n,
            currentMin,
            i18nListingsData?.to,
            false,
            0,
        )} - ${getFormattedCurrency(i18n, currentMax, i18nListingsData?.to, false, 0)}${plusSignString}`
        setButtonLabel(label)
    }, [currentMin, currentMax, i18n, i18nListingsData?.to, plusSignString])

    return (
        <Menu className={styles.menu}>
            <ButtonV2 className={btnClassname} onClick={onClick} data-testid="price-filter-btn">
                <div className={styles.filterButtonText}>
                    <Text className={styles.filterOptionText}>{buttonLabel}</Text>
                </div>
            </ButtonV2>
        </Menu>
    )
}
export default PriceFilterButton
